<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.product$ | async; as product) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >PRODUCTLINE_LBL_NAME</label
                        >
                        <div class="form-title">{{ product.name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >PRODUCT_LBL_PRODUCTCATEGORYNAME</label
                          >
                          <div class="col">
                            <span
                              class="form-control-plaintext form-control-sm h-100"
                              >
                              <app-link-to [id]="product.productCategoryId.toString()"
                                [label]="product.productLineProductCategoryName"
                                [url]="'/Insurance/ProductCategories/Details/'"/>
                              </span>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-4 col-form-label-sm" translate
                              >PRODUCT_LBL_INSURANCECOMPANYNAME</label
                              >
                              <div class="col">
                                <span
                                  class="form-control-plaintext form-control-sm h-100"
                                  >
                                  <app-link-to [id]="product.productLineInsuranceCompanyId.toString()"
                                    [label]="product.productLineInsuranceCompanyContactName"
                                    [url]="'/Insurance/InsuranceCompanies/Details/'"/>
                                  </span>
                                </div>
                              </div>
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                  >PRODUCT_LBL_PRODUCTLINENAME</label
                                  >
                                  <div class="col">
                                    <span
                                      class="form-control-plaintext form-control-sm h-100"
                                      >
                                      <app-link-to [id]="product.productLineId.toString()"
                                        [label]="product.productLineName"
                                        [url]="'/Insurance/ProductLines/Details/'"/>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="form-group row">
                                    <label class="col-4 col-form-label-sm" translate
                                      >PRODUCT_LBL_STARTDATE</label
                                      >
                                      <div class="col">
                                        <span
                                          class="form-control-plaintext form-control-sm h-100"
                                          >
                                          {{ product.startDate | date : "dd/MM/yyyy" }}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="form-group row">
                                      <label class="col-4 col-form-label-sm" translate
                                        >PRODUCT_LBL_ENDDATE</label
                                        >
                                        <div class="col">
                                          <span
                                            class="form-control-plaintext form-control-sm h-100"
                                            >
                                            {{ product.endDate | date : "dd/MM/yyyy" }}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="form-group row">
                                        <label class="col-4 col-form-label-sm" translate
                                          >PRODUCT_LBL_TAXRATE</label
                                          >
                                          <div class="col">
                                            <span
                                              class="form-control-plaintext form-control-sm h-100"
                                              >
                                              {{ product.taxRate }} %
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <app-product-tabs-details/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        @if (this.product$ | async; as product) {
                          <div class="col-comment">
                            <app-comment-panel
                              [entityType]="'Product'"
                              [entityId]="product.id.toString()"
                            ></app-comment-panel>
                          </div>
                        }
                      </div>
                    </div>
